export default __webpack_public_path__ + "b64b55874e6b57ab8e9f10e1c00c6af7.png";